import {createApp, defineAsyncComponent} from 'vue';
import {i18n} from '../../setup/i18n';
import emitter from "../../setup/bus";
import { createPinia } from 'pinia';

export default function init() {
    let element = document.querySelector('.toggle-search');
    let quicksearchElement = document.querySelector("#quicksearch");
    if(quicksearchElement) {
        mountQuicksearch(quicksearchElement);
    }

    if(element) {
        element.addEventListener('click', activateSearch);
    }

    function activateSearch(e) {
        e.preventDefault();
        if (!document.body.classList.contains('active-quick-search')) {
            document.body.classList.add('active-quick-search');
        }
        e.stopPropagation();
    }

    function mountQuicksearch(el) {
        const pinia = createPinia();
        const app = createApp({});
        app.config.globalProperties.$bus = emitter;
        app.provide('$bus', emitter);
        app.use(pinia)
            .use(i18n)
            .component(
                'Quicksearch',
                defineAsyncComponent(() => import('./Quicksearch.vue'))
            )
            .mount(el);
    }
}
